import { Col, Container, Tab, Row, Nav } from "react-bootstrap";
import colorSharp2 from "../assets/img/color-sharp2.png";
import arcommerce from "../assets/img/arcommerce.png";
import safebite from "../assets/img/safebite.png";
import TrackVisibility from "react-on-screen";
import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { TranslatedText } from "../components/TranslatedText";

export const Projects = () => {
  const { language } = useLanguage();
  const [hoveredProject, setHoveredProject] = useState(null);
  
  const projects = [
    {
      id: "first",
      titleKey: "arcommerce",
      descriptionKey: "arcommerceDescription",
      imgUrl: arcommerce,
      link: "https://example.com/arcommerce", // Placeholder link
      tech: ["Spring Boot", "Angular", "PostgreSQL", "Three.js", "WebXR"]
    },
    {
      id: "second",
      titleKey: "safebite",
      descriptionKey: "safebiteDescription",
      imgUrl: safebite,
      link: "https://example.com/safebite", // Placeholder link
      tech: ["Next.js", "Prisma", "Tailwind CSS", "PostgreSQL"]
    }
  ];
  
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate_animated animate_slideInUp" : ""}>
                  <h2><TranslatedText textKey="projects" /></h2>
                </div>
              )}
            </TrackVisibility>
            
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
                defaultActiveKey="/home"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">ARCommerce</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">SafeBite</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third"><TranslatedText textKey="toBeContinued" /></Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                {projects.map((project) => (
                  <Tab.Pane key={project.id} eventKey={project.id}>
                    <Row className="align-items-center">
                      <Col md={6} className="mb-4 mb-md-0">
                        <div 
                          className="project-image-container"
                          onMouseEnter={() => setHoveredProject(project.id)}
                          onMouseLeave={() => setHoveredProject(null)}
                        >
                          <img 
                            src={project.imgUrl} 
                            alt={project.titleKey === "arcommerce" ? "ARCommerce" : "SafeBite"} 
                            className="img-fluid rounded project-detail-image"
                          />
                          {hoveredProject === project.id && (
                            <div className="project-overlay">
                              <a 
                                href={project.link} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="project-link"
                              >
                                <TranslatedText textKey="viewProject" />
                              </a>
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={6}>
                        <h3>{project.titleKey === "arcommerce" ? "ARCommerce" : "SafeBite"}</h3>
                        <p><TranslatedText textKey={project.descriptionKey} /></p>
                        <div className="mt-3">
                          <h5><TranslatedText textKey="technologiesUsed" />:</h5>
                          <div className="d-flex flex-wrap">
                            {project.tech.map((tech, index) => (
                              <span key={index} className="badge bg-secondary me-2 mb-2 p-2">
                                {tech}
                              </span>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>
                ))}
                <Tab.Pane eventKey="third">
                  <div className="text-center py-5">
                    <h4><TranslatedText textKey="projectSuggestion" /></h4>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background" />
    </section>
  );
};